import { CloseButton } from "../../atoms/CloseButton";
import { IconProps } from "../../atoms/Icon";
import { AlertIcon, getTextColor, Inner, Root } from "./styles";
import type { AlertLevel, AlertProps } from "./types";

const getIconFromVariant = (level: AlertLevel): IconProps["icon"] => {
  switch (level) {
    case "success":
      return "success";
    case "warning":
      return "error";
    case "error":
      return "error";
    default:
      return "info";
  }
};

export function Alert({
  level = "info",
  onDismissClick,
  entitySize = "m",
  children,
  ...rest
}: AlertProps) {
  const textColor = getTextColor(level);
  return (
    <Root data-testid={Alert.name} role="alert" $entitySize={entitySize} $level={level} {...rest}>
      <div>
        <AlertIcon color={textColor} icon={getIconFromVariant(level)} />
      </div>
      <Inner>
        <div>{children}</div>
      </Inner>
      {onDismissClick && (
        <div>
          <CloseButton color={textColor} onClick={onDismissClick} />
        </div>
      )}
    </Root>
  );
}
